import { render, staticRenderFns } from "./AccountTurnMenu.vue?vue&type=template&id=4ed05928&"
import script from "./AccountTurnMenu.vue?vue&type=script&lang=js&"
export * from "./AccountTurnMenu.vue?vue&type=script&lang=js&"
import style0 from "./AccountTurnMenu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports